$(document).ready(function() {
    premiumSearch.initiate();
});

var premiumSearch = {
    initiate: function() {
        $('#premium_search .button-do-search').on('click', this.doSearch);
    },
    doSearch: function(e) {
        var category = $('#premium_search select.category').val();
        var region = $('#premium_search select.region').val();
        var occasion = $('#premium_search select.occasion').val();

        var url = new URL(location.href);

        var urlParts = [];

        if (occasion !== "-1") {
            url.searchParams.set('occasion_id', occasion)
        }

        if (region !== "-1") {
            url.searchParams.set('region_id', region)
        }

        if (category !== "-1") {
            url.searchParams.set('category_id', category)
        }

        window.location = url.toString();
    }
};
